import type { FC, SVGProps } from 'react';

export const CopyIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.9996 0H3.62463C3.55588 0 3.49963 0.05625 3.49963 0.125V1C3.49963 1.06875 3.55588 1.125 3.62463 1.125H11.3746V11.875C11.3746 11.9438 11.4309 12 11.4996 12H12.3746C12.4434 12 12.4996 11.9438 12.4996 11.875V0.5C12.4996 0.223437 12.2762 0 11.9996 0ZM9.99963 2H1.99963C1.72307 2 1.49963 2.22344 1.49963 2.5V10.7922C1.49963 10.925 1.55276 11.0516 1.64651 11.1453L4.35432 13.8531C4.3887 13.8875 4.42776 13.9156 4.46995 13.9391V13.9688H4.53557C4.59026 13.9891 4.64807 14 4.70745 14H9.99963C10.2762 14 10.4996 13.7766 10.4996 13.5V2.5C10.4996 2.22344 10.2762 2 9.99963 2ZM4.46838 12.3781L3.12307 11.0312H4.46838V12.3781ZM9.37463 12.875H5.46838V10.6562C5.46838 10.3109 5.1887 10.0312 4.84338 10.0312H2.62463V3.125H9.37463V12.875Z"
    />
  </svg>
);
